import hotkeys from 'hotkeys-js';
import { useCallback, useEffect } from 'react';

function useHotkeys(_ref) {
  var keys = _ref.keys,
      handler = _ref.handler,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var memoizedCallback = useCallback(handler, deps);
  useEffect(function () {
    hotkeys(keys, options, memoizedCallback);
    return function () {
      return hotkeys.unbind(keys);
    };
  }, [memoizedCallback]);
}

export default useHotkeys;
//# sourceMappingURL=useHotkeys.js.map
